interface HomeIndicatorProps {
  className?: string;
}

export default function HomeIndicator(props: HomeIndicatorProps) {
  const { className } = props;

  return (
    <div className={`flex p-2 justify-center ${className ?? ''}`}>
      <div className="w-[134px] h-[5px] rounded-full bg-black dark:bg-white" />
    </div>
  );
}
